import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";
import { useCadreRef } from "../../hooks/applicationHooks/useCadreRef";

import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";

export interface CadreSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const CadreSelect: React.FunctionComponent<CadreSelectProps> = ({
  name,
  label,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { cadres, cadresLoading } = useCadreRef();

  return (
    <FGSelectInput
      label={label || t("Cadre")}
      name={name}
      items={cadres}
      loading={cadresLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default CadreSelect;
